// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 20px;
  overflow: hidden;
}
.modal__content {
  width: 100%;
  height: 90%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  border-radius: 12px 12px 0 0;
}
.modal__content__heading {
  text-align: center;
  position: relative;
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal__content__heading .regular-text {
  font-weight: 600;
  color: #192E33;
}
.modal__content__heading .transformed {
  transform: rotate(90deg);
  position: absolute;
  left: 16px;
}
.modal__content .modal-action-btn {
  width: 40px;
  height: 40px;
}
.modal__content .outlined-btn {
  position: absolute;
  right: 16px;
}
.modal__content__body {
  padding: 24px 16px;
  max-height: calc(100% - 44px);
  overflow-y: auto;
  overflow-x: hidden;
}
.modal__content__body::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: transparent;
}
.modal__content__body::-webkit-scrollbar-thumb {
  background-color: transparent;
}
.modal.animate-top {
  animation: fadeIn 0.3s ease-out both;
}
.modal.animate-top .modal__content {
  transform: translateY(100%);
  animation: animateTop 0.3s ease-out both 0.2s;
}
.modal .search-wrapper {
  z-index: 9999;
  background-color: #fff;
  position: sticky;
  margin-top: -24px;
  top: -24px;
  padding-bottom: 4px;
  margin-bottom: 24px;
}
@keyframes animateTop {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common/Modal/Modal.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;AACF;AAAE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,sBAAA;EACA,4BAAA;AAEJ;AADI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGN;AAFM;EACE,gBAAA;EACA,cAAA;AAIR;AAFM;EACE,wBAAA;EACA,kBAAA;EACA,UAAA;AAIR;AADI;EACE,WAAA;EACA,YAAA;AAGN;AADI;EACE,kBAAA;EACA,WAAA;AAGN;AADI;EACE,kBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AAGN;AADM;EACE,UAAA;EACA,WAAA;EACA,6BAAA;AAGR;AAAM;EACE,6BAAA;AAER;AAEE;EACE,oCAAA;AAAJ;AACI;EACE,2BAAA;EACA,6CAAA;AACN;AAEE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;AAAJ;AAEE;EACE;IACE,2BAAA;IACA,UAAA;EAAJ;EAEE;IACE,yBAAA;IACA,UAAA;EAAJ;AACF;AAGE;EACE;IACE,UAAA;EADJ;EAGE;IACE,UAAA;EADJ;AACF","sourcesContent":["@import \"src/assets/styles/variables\";\n\n.modal{\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  background-color: rgba(#000, .4);\n  border-radius: 20px;\n  overflow: hidden;\n  &__content{\n    width: 100%;\n    height: 90%;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: #fff;\n    border-radius: 12px 12px 0 0;\n    &__heading{\n      text-align: center;\n      position: relative;\n      min-height: 68px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      .regular-text{\n        font-weight: 600;\n        color: #192E33;\n      }\n      .transformed{\n        transform: rotate(90deg);\n        position: absolute;\n        left: 16px;\n      }\n    }\n    .modal-action-btn{\n      width: 40px;\n      height: 40px;\n    }\n    .outlined-btn{\n      position: absolute;\n      right: 16px;\n    }\n    &__body{\n      padding: 24px 16px;\n      max-height: calc(100% - 44px);\n      overflow-y: auto;\n      overflow-x: hidden;\n\n      &::-webkit-scrollbar {\n        width: 4px;\n        height: 4px;\n        background-color: transparent;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: transparent;\n      }\n    }\n  }\n  &.animate-top{\n    animation: fadeIn .3s ease-out both;\n    .modal__content{\n      transform: translateY(100%);\n      animation: animateTop .3s ease-out both .2s;\n    }\n  }\n  .search-wrapper{\n    z-index: 9999;\n    background-color: #fff;\n    position: sticky;\n    margin-top: -24px;\n    top: -24px;\n    padding-bottom: 4px;\n    margin-bottom: 24px;\n  }\n  @keyframes animateTop {\n    0%{\n      transform: translateY(100%);\n      opacity: 0;\n    }\n    100%{\n      transform: translateY(0%);\n      opacity: 1;\n    }\n  }\n\n  @keyframes fadeIn {\n    0%{\n      opacity: 0;\n    }\n    100%{\n      opacity: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
